export default "__VITE_ASSET__$7C6bmZV__"